import React, { useEffect, useMemo, useState } from 'react';

import { StyledContainerFolder } from './styles';

import EmptyState from '../EmptyState';
import File from '../File';
import SkeletonFile from '../SkeletonFile';

import NoFilesIcon from '../../assets/novosicones/Sindico/NoFiles.svg';

export default function FilesContainer({
  files,
  loadMoreFiles,
  loadFolderFiles,
  maxPages = 1,
  currentPage = 1,
  qntFiles = 0,
  onOpenFile,
}) {
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingMoreFiles, setIsLoadingMoreFiles] = useState(false);

  const showFiles = useMemo(() => {
    return !isLoading && files && files?.length > 0;
  }, [isLoading, files]);

  const showEmptyState = useMemo(() => {
    return !isLoading && (!files || (files && files.length === 0));
  }, [isLoading, files]);

  const qntFilesText = useMemo(() => {
    return `${qntFiles} ${qntFiles > 1 ? 'arquivos' : 'arquivo'}. `;
  }, [qntFiles]);

  const showLoadMoreFiles = useMemo(() => {
    return !isLoading && currentPage < maxPages;
  }, [isLoading, currentPage, maxPages]);

  async function handleLoadMoreFiles() {
    try {
      setIsLoadingMoreFiles(true);
      if (loadMoreFiles) {
        await loadMoreFiles();
      }
    } finally {
      setIsLoadingMoreFiles(false);
    }
  }

  useEffect(() => {
    async function handleLoadFolderFiles() {
      try {
        setIsLoading(true);
        await loadFolderFiles();
      } finally {
        setIsLoading(false);
      }
    }
    handleLoadFolderFiles();
  }, []);

  return (
    <StyledContainerFolder>
      <div className='files'>
        {showFiles &&
          files &&
          files.map((file) => (
            <File key={file?.id} file={file} onOpenFile={onOpenFile} />
          ))}
        {isLoading && <SkeletonFile count={3} />}
        {isLoadingMoreFiles && (
          <SkeletonFile count={3} hideButtonLoadMoreFiles />
        )}
        {showEmptyState && (
          <EmptyState
            icon={NoFilesIcon}
            title='Ainda não há arquivos nesta pasta'
            // subtitle='Adicione arquivos clicando no botão “Novo”'
          />
        )}
        <div className='container-load-files-and-qnt'>
          {!isLoading && qntFiles > 0 && (
            <span className='qnt-files'>{qntFilesText}</span>
          )}
          {!isLoading && showLoadMoreFiles && (
            <button
              className='load-more-files'
              disabled={isLoadingMoreFiles}
              onClick={handleLoadMoreFiles}
            >
              <span>Ver mais</span>
            </button>
          )}
        </div>
      </div>
    </StyledContainerFolder>
  );
}
